function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ReactOnRails from 'react-on-rails';
import { exists } from '@engine/lib/utility/exists';

function removeErrorElementsOnEmailFieldset() {
  var $emailFieldsetContainer = $('.email-fieldset');
  $emailFieldsetContainer.find('.help-block').remove();
  $emailFieldsetContainer.find('.has-error').removeClass('has-error');
  $emailFieldsetContainer.find('input:not([type="radio"]), select').prop('value', '');
}

function disableInputForEmail() {
  $('.consumer-email-input').addClass('hidden').find('input').prop('disabled', true);
}

function enableInputForEmail() {
  $('.consumer-email-input').removeClass('hidden').find('input').prop('disabled', false);
}

function disableConsumerSelectForEmail() {
  $('.consumer-email-select-wrapper').addClass('hidden').find('select, input[type="hidden"]').prop('disabled', true);
}

function enableConsumerSelectForEmail() {
  $('.consumer-email-select-wrapper').removeClass('hidden').find('select, input').prop('disabled', false);
}

function toggleConsumerSelect(isSelectActive) {
  var $consumerSelectWrapper = $('.consumer-email-select');

  if (isSelectActive) {
    $consumerSelectWrapper.show();
    $consumerSelectWrapper.find('select, input').prop('disabled', false);
  } else {
    $consumerSelectWrapper.hide();
    $consumerSelectWrapper.find('select, input').prop('disabled', true);
  }
}

function loadConsumerEmailSelect(terminalId) {
  var component = $('script[data-component-name="CustomerEmailContainer"]');

  if (!exists(component)) {
    return;
  }

  var componentName = 'CustomerEmailContainer';
  var componentId = component.attr('data-dom-id');
  var componentProps = JSON.parse(component.text());
  ReactOnRails.render(componentName, _objectSpread(_objectSpread({}, componentProps), {}, {
    terminalId: terminalId
  }), componentId);
}

function handleEmailFieldType() {
  var isEmailFieldAnInput = $('#email-field-input').prop('checked');

  if (isEmailFieldAnInput) {
    toggleConsumerSelect(false);
    enableInputForEmail();
  } else {
    toggleConsumerSelect(true);
    disableInputForEmail();
  }
}

function attachEmailSwitchListener() {
  var switchSelector = '.consumer-field-options input';

  if (exists($(switchSelector))) {
    $('body').on('change', switchSelector, function () {
      handleEmailFieldType();
      removeErrorElementsOnEmailFieldset();
    });
  }
}

function updateConsumerFields(hasConsumers, terminalId) {
  var $switchButton = $('.consumer-field-options input');

  if (hasConsumers) {
    loadConsumerEmailSelect(terminalId);
    enableConsumerSelectForEmail();
    handleEmailFieldType();
    $switchButton.prop('disable', false);
  } else {
    enableInputForEmail();
    toggleConsumerSelect(false);
    disableConsumerSelectForEmail();
    $switchButton.prop('disable', true);
  }
}

var PayByLinkConsumers = {
  updateFields: updateConsumerFields,
  attachEmailSwitchListener: attachEmailSwitchListener
};
export default PayByLinkConsumers;